import { render, staticRenderFns } from "./system_management_home.vue?vue&type=template&id=07fa153b&scoped=true&"
import script from "./system_management_home.vue?vue&type=script&lang=js&"
export * from "./system_management_home.vue?vue&type=script&lang=js&"
import style0 from "./system_management_home.vue?vue&type=style&index=0&id=07fa153b&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07fa153b",
  null
  
)

export default component.exports